module.exports = __webpack_public_path__ + "static/media/ledneon (2).849fa95d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/LedNeon/ledneon (2).jpg
// module id = 330
// module chunks = 0